import { render, staticRenderFns } from "./ProfileDropdown.vue?vue&type=template&id=5e9f56b4&scoped=true"
import script from "./ProfileDropdown.vue?vue&type=script&lang=js"
export * from "./ProfileDropdown.vue?vue&type=script&lang=js"
import style0 from "./ProfileDropdown.vue?vue&type=style&index=0&id=5e9f56b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9f56b4",
  null
  
)

export default component.exports